import AppGuid from "../admin/guide/forms/AppGuid";

const PublicGuid = () => {
  return (
    <div style={{ height: "100%" }}>
      <AppGuid
        title="Bonjour et bienvenu sur le guide d'utilisation du plateforme."
        description="Retrouvez ici les étapes pour utiliser le plateforme de manière efficace et résoudre les problèmes courants que vous pourriez rencontrer en tant qu'utilisateur."
        maj="01 Février 2026"
      />
    </div>
  );
};

export default PublicGuid;
